"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const experiments_1 = require("../constants/experiments");
exports.default = () => {
    return Math.random() * 100 < experiments_1.CONTROL_TEST_PERCENTAGE;
};
//# sourceMappingURL=shouldAssignToAATest.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/utils/shouldAssignToAATest.js
// module id = RjNl
// module chunks = 65